import { render, staticRenderFns } from "./UploaderItem.vue?vue&type=template&id=2e875942&scoped=true"
import script from "./UploaderItem.vue?vue&type=script&lang=js"
export * from "./UploaderItem.vue?vue&type=script&lang=js"
import style0 from "./UploaderItem.vue?vue&type=style&index=0&id=2e875942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e875942",
  null
  
)

export default component.exports